export default __webpack_public_path__ + "dcc9853e5f3c9f5540e923f91f6e357e.svg";